import { UserConfig } from "./Config";
import { TipsMap } from "./Game";

export enum GameStreamProtocol {
  AUTO = "auto",
  WEBRTC = "webrtc",
  UDP = "udp",
  TCP = "tcp",
}

export enum GStreamerOption {
  OFF = "off",
  AUTO = "auto",
  TCP = "tcp",
  UDP = "udp",
}

export enum StreamStatus {
  Pending = "pending",
  Running = "running",
  Playing = "playing",
  Error = "error",
  Cancelled = "cancelled",
}
export enum StreamServerStatus {
  Configuring = "configuring_game",
  Use = "in_use",
  Pending = "pending",
}

export enum UDPOption {
  None = "none",
  RepeatPacket = "udp_repeat_packet",
  RepeatFrame = "udp_repeat_frame",
  Nack = "udp_nack",
}
export interface Stream {
  id: string;
  status: StreamStatus;
  gameId?: string;
  serverStatus?: StreamServerStatus;
  url?: string;
  rtsp?: string;
  protocol: GameStreamProtocol;
  audid?: string;
  inputPort?: number;
  webrtcConfig?: RTCIceServer[];
  virtualGamepadUrl?: string;
  inputDevice?: "absolute" | "relative";
  token?: string;
  uuid: string;
}

export interface Meta {
  message: string;
  refreshIn?: number;
  timeLeft?: number;
  title?: string;
  errorCode?: string;
}
export declare type StreamMeta = Meta;

export default interface GameStream {
  stream: Stream;
  meta: Meta;
  tips?: TipsMap;
  userConf?: UserConfig;
}
export { GameStream };
